export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'USER_SETTINGS_SET':
      if (payload && payload.length === undefined) {
        payload.valueArray = payload.value ? JSON.parse(payload.value) : []
        return [payload]
      } else {
        let newState = [...state]
        payload.map(s => {
          s.valueArray = JSON.parse(s.value)
          if (newState.find(setting => setting.settingId === s.settingId)) {
            newState = newState.map(setting => (setting.settingId === s.settingId ? s : setting))
          } else {
            newState.push(s)
          }
        })
        return newState
      }

    case 'LOGOUT':
      return []
    default:
      return state
  }
}
